var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconUnfollow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_133_16065)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#222834"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2188 9.375L12.5938 12L15.2188 14.625C15.3021 14.7083 15.3438 14.8073 15.3438 14.9219C15.3438 15.0365 15.3021 15.1354 15.2188 15.2188C15.1354 15.3021 15.0365 15.3438 14.9219 15.3438C14.8073 15.3438 14.7083 15.3021 14.625 15.2188L12 12.5938L9.375 15.2188C9.29167 15.3021 9.19271 15.3438 9.07813 15.3438C8.96354 15.3438 8.86458 15.3021 8.78125 15.2188C8.69792 15.1354 8.65625 15.0365 8.65625 14.9219C8.65625 14.8073 8.69792 14.7083 8.78125 14.625L11.4063 12L8.78125 9.375C8.69792 9.29167 8.65625 9.19271 8.65625 9.07813C8.65625 8.96354 8.69792 8.86458 8.78125 8.78125C8.86458 8.69792 8.96354 8.65625 9.07813 8.65625C9.19271 8.65625 9.29167 8.69792 9.375 8.78125L12 11.4063L14.625 8.78125C14.7083 8.69792 14.8073 8.65625 14.9219 8.65625C15.0365 8.65625 15.1354 8.69792 15.2188 8.78125C15.3021 8.86458 15.3438 8.96354 15.3438 9.07813C15.3438 9.19271 15.3021 9.29167 15.2188 9.375Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_133_16065"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(24 1.04907e-06) rotate(90)"
})))));
export default SvgIconUnfollow;